<template>
    <div class="affProgrammes">
        <page-navigate></page-navigate>
        <div class="affPro-header text-center flex flex-col justify-between items-center">
            <img class="bgImg" src="@/assets/image/partner2/s1Bg.webp"></img>
            <div>
                <h1 class="super_large-80_bold md-title-32_bold">合作伙伴计划</h1>
                <h2 class="subtitle-20_regular secondary-white md-body-14_regular">
                    这不仅是一项定制化合作伙伴计划，更是一条已验证的持续收益之旅。
                </h2>
                <a class="primary-default_large" :href="signupUrl" target="_blank">
                    <span>加入我们</span>
                </a>
            </div>
            <div class="flex items-center justify-center affPro-headerContent">
                <div>
                    <div class="affPro-headerNum"></div>
                    <div class="body-16_regular md-body-14_regular secondary-white">
                        全球合作伙伴
                    </div>
                </div>
                <div>
                    <div class="affPro-headerNum"></div>
                    <div class="body-16_regular md-body-14_regular secondary-white">
                        合作媒体
                    </div>
                </div>

                <div>
                    <div class="affPro-headerNum"></div>
                    <div class="body-16_regular md-body-14_regular secondary-white">
                        每月佣金支付
                    </div>
                </div>
                <div>
                    <div class="affPro-headerNum"></div>
                    <div class="body-16_regular md-body-14_regular secondary-white">
                        国家
                    </div>
                </div>
            </div>
        </div>
        <div class="affPro-section2">
            <h2 class="title-48_bold md-subtitle-20_bold text-center scroll-fade-up">
                携手全球最佳券商<br />
                成就您的持续收益与行业影响力
            </h2>
            <a :href="signupUrl" target="_blank" class="secondary-white-default_large scroll-fade-up">立即加入</a>
            <div class="photoList flex flex-wrap justify-between scroll-fade-up">
                <div class="photoItem opa80 bgc1 opa2 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P1.png" alt=""></div>
                <div class="photoItem opa50 bgc2 opa1 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P2.png" alt=""></div>
                <div class="photoItem opa60 bgc3 opa2 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P3.png" alt=""></div>
                <div class="photoItem opa60 bgc4 opa2 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P4.png" alt=""></div>
                <div class="photoItem opa60 bgc4 opa2 blur5" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P5.png" alt=""></div>
                <div class="photoItem opa100 bgc4 opa4" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P6.png" alt=""></div>
                <div class="photoItem opa60 bgc5 opa2 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P7.png" alt=""></div>
                <div class="photoItem opa80 bgc4 opa3 blur2" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P8.png" alt=""></div>
                <div class="photoItem opa50 bgc3 opa2 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P9.png" alt=""></div>
                <div class="photoItem opa60 bgc2 opa1 blur5" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P10.png" alt=""></div>
                <div class="photoItem opa60 bgc4 opa1 blur5" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P11.png" alt=""></div>
                <div class="photoItem opa80 bgc4 opa2 blur2" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P12.png" alt=""></div>
                <div class="photoItem opa60 bgc2 opa1 blur5" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P13.png" alt=""></div>
                <div class="photoItem opa100 bgc4 opa7" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P14.png" alt=""></div>
                <div class="photoItem opa80 bgc6 opa2 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P15.png" alt=""></div>
                <div class="photoItem opa60 bgc4 opa1 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P16.png" alt=""></div>
                <div class="photoItem opa100 bgc2 opa4" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P17.png" alt=""></div>
                <div class="photoItem opa60 bgc3 opa2 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P18.png" alt=""></div>
                <div class="photoItem opa60 bgc1 opa2 blur5" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P19.png" alt=""></div>
                <div class="photoItem opa80 bgc5 opa1 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P20.png" alt=""></div>
                <div class="photoItem opa50 bgc4 opa1 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P21.png" alt=""></div>
                <div class="photoItem opa50 bgc2 opa2 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P22.png" alt=""></div>
                <div class="photoItem opa60 bgc5 opa3 blur5" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P23.png" alt=""></div>
                <div class="photoItem opa60 bgc4 opa2 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P24.png" alt=""></div>
                <div class="photoItem opa100 bgc4 opa7" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P25.png" alt=""></div>
                <div class="photoItem opa50 bgc2 opa2 blur5" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P26.png" alt=""></div>
                <div class="photoItem opa60 bgc1 opa2 blur2" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P27.png" alt=""></div>
                <div class="photoItem opa60 bgc4 opa1 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P28.png" alt=""></div>
                <div class="photoItem opa50 bgc2 opa3 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P29.png" alt=""></div>
                <div class="photoItem opa60 bgc5 opa2 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P30.png" alt=""></div>
                <div class="photoItem opa60 bgc5 opa1 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P31.png" alt=""></div>
                <div class="photoItem opa60 bgc4 opa05 blur2" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P32.png" alt=""></div>
                <div class="photoItem opa60 bgc2 opa2 blur5" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P33.png" alt=""></div>
                <div class="photoItem opa80 bgc1 opa1 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P34.png" alt=""></div>
                <div class="photoItem opa60 bgc4 opa1 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P35.png" alt=""></div>
                <div class="photoItem opa80 bgc4 opa2 blur2" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P36.png" alt=""></div>
                <div class="photoItem opa100 bgc4 opa5" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P37.png" alt=""></div>
                <div class="photoItem opa50 bgc5 opa2 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P38.png" alt=""></div>
                <div class="photoItem opa50 bgc6 opa1 blur3" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P39.png" alt=""></div>
                <div class="photoItem opa60 bgc4 opa1 blur5" target="_blank""><img class=" lazyload" decoding="async"
                    src="@/assets/image/partner2/s2P40.png" alt=""></div>
            </div>
        </div>
        <div class="affPro-section3">
            <div class="contentBox">
                <h2 class="title-48_bold md-subtitle-20_bold text-center scroll-fade-up">
                    选择您的合作方式
                </h2>
                <div class="affPro-section3CardList flex justify-between items-stretch scroll-fade-up">
                    <div class="affPro-section3Card flex justify-between items-start active">
                        <div class="controlShow flex flex-col items-start justify-between">
                            <div class="affPro-s2CardTitle">介绍经纪人（IB）</div>
                            <div class="subtitle-20_regular md-content-16_regular">
                                高额分佣，持续稳定收益
                            </div>
                            <div class="body-16_regular md-content-14_regular secondary-black">
                                成功推荐客户获得丰厚返佣，EBC 卓越的交易环境，让您实现收益潜力最大化。 
                            </div>
                            <a href="javaScript:;" id="ibBtn" class="content-16_medium md-body-14_medium">了解更多</a>
                        </div>
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s2Model1.png" alt="" />
                    </div>
                    <div class="affPro-section3Card flex justify-between items-start">
                        <div class="controlShow flex flex-col items-start justify-between">
                            <div class="affPro-s2CardTitle">联盟合作伙伴</div>
                            <div class="subtitle-20_regular md-content-16_regular">
                                佣金每日结算
                            </div>
                            <div class="body-16_regular md-content-14_regular secondary-black">
                                佣金丰厚且随时取款，平台数据透明，让您轻松将流量变现。 
                            </div>
                            <a href="/partners/affiliate" target="_blank" class="content-16_medium md-body-14_medium">了解更多</a>
                        </div>
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s2Model2.png" alt="" />
                    </div>
                    <div class="affPro-section3Card flex justify-between items-start">
                        <div class="controlShow flex flex-col items-start justify-between">
                            <div class="affPro-s2CardTitle">策略支持者</div>
                            <div class="subtitle-20_regular md-content-16_regular">
                                全渠道流量
                            </div>
                            <div class="body-16_regular md-content-14_regular secondary-black">
                                百亿级流量曝光和全球品牌联动，让您的专业能力转化为可持续收益与更大影响力。
                            </div>
                            <a href="/activityList/creator-incentives" target="_blank"
                                class="content-16_medium md-body-14_medium">了解更多</a>
                        </div>
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s2Model3.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
        <div class="affPro-section4">
            <div class="contentBox">
                <h2 class="title-40_bold md-subtitle-20_bold scroll-fade-up text-center">合作伙伴支持</h2>
                <div class="flex aff4Container scroll-fade-up justify-between flex-wrap items-stretch">
                    <div class="aff4Item">
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s4Model.png" alt="">
                        <div class="s4Word">
                            <div class="title-24_medium">丰厚佣金和极速支付</div>
                            <div class="content-16_regular secondary-white">丰厚佣金无上限，固定日结，多渠道极速到账。</div>
                        </div>
                    </div>
                    <div class="aff4Item">
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s4Model2.png" alt="">
                        <div class="s4Word">
                            <div class="title-24_medium">全链路营销支持</div>
                            <div class="content-16_regular secondary-white">核心合作伙伴可申请定制化合作/推广方案 
                                协助知识型创作者内容整合，与行业顶尖专家建立联系，扩大影响力。</div>
                        </div>
                    </div>
                    <div class="aff4Item">
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s4Model3.svg" alt="">
                        <div class="s4Word">
                            <div class="title-24_medium">全球交易者信赖</div>
                            <div class="content-16_regular secondary-white">受多国权威监管，服务覆盖超100个国家与地区。</div>
                        </div>
                    </div>
                    <div class="aff4Item">
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s4Model4.svg" alt="">
                        <div class="s4Word">
                            <div class="title-24_medium">全球服务团队</div>
                            <div class="content-16_regular secondary-white">本土化团队全天候服务，随时响应。</div>
                        </div>
                    </div>
                    <div class="aff4Item">
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s4Model5.svg" alt="">
                        <div class="s4Word">
                            <div class="title-24_medium">交易支持</div>
                            <div class="content-16_regular secondary-white">87.6%订单优化率，专属工具库提升盈利表现。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="affPro-section5">
            <div class="contentBox">
                <h2 class="title-48_bold md-subtitle-20_bold text-center scroll-fade-up">
                    发现您的匹配机会
                </h2>
                <div class="s3SwiperContainer flex justify-between items-center scroll-fade-up">
                    <div class="left">
                        <div class="swiper s3Swiper">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide slide1">
                                    <img class="lazyload" decoding="async"
                                        src="@/assets/image/partner2/s3Model1.webp" alt="" />
                                </div>
                                <div class="swiper-slide slide2">
                                    <img class="lazyload" decoding="async"
                                        src="@/assets/image/partner2/s3Model2.webp" alt="" />
                                </div>
                                <div class="swiper-slide slide3">
                                    <img class="lazyload" decoding="async"
                                        src="@/assets/image/partner2/s3Model3.webp" alt="" />
                                </div>
                                <div class="swiper-slide slide4">
                                    <img class="lazyload" decoding="async"
                                        src="@/assets/image/partner2/s3Model4.webp" alt="" />
                                </div>
                                <div class="swiper-slide slide5">
                                    <img class="lazyload" decoding="async"
                                        src="@/assets/image/partner2/s3Model5.webp" alt="" />
                                </div>
                                <div class="swiper-slide slide6">
                                    <img class="lazyload" decoding="async"
                                        src="@/assets/image/partner2/s3Model6.webp" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="s3wordList">
                            <div class="s3wordItem active">
                                <div class="s3Title title-32_bold md-subtitle-20_medium">门户网站</div>
                                <div class="s3Desc secondary-black body-14_regular md-content-14_regular">
                                    将您的权威内容与精准流量，转化为可持续的客户线索与收益增长。作为金融信息的枢纽，您的每一篇市场分析、每一次行情更新，都蕴藏着高价值的潜在客户。
                                </div>
                            </div>
                            <div class="s3wordItem">
                                <div class="s3Title title-32_bold md-subtitle-20_medium">联盟伙伴</div>
                                <div class="s3Desc secondary-black body-14_regular md-content-14_regular">
                                    无论网站/博客，媒体KOL、互联网营销还是其他资源，我们将您的每一个渠道与每一次推荐，转化为透明、即时且无上限的佣金回报。
                                </div>
                            </div>
                            <div class="s3wordItem">
                                <div class="s3Title title-32_bold md-subtitle-20_medium">交易社群</div>
                                <div class="s3Desc secondary-black body-14_regular md-content-14_regular">
                                    将您凝聚的交易智慧与社群信任，扩展为更具影响力的知识品牌与商业闭环。我们可以共同开发课程、联合举办活动，或为您的内容提供专业背书，将社群影响力转化为可持续的教育产品与品牌收益。
                                </div>
                            </div>
                            <div class="s3wordItem">
                                <div class="s3Title title-32_bold md-subtitle-20_medium">网络达人</div>
                                <div class="s3Desc secondary-black body-14_regular md-content-14_regular">
                                    您的专业分析、实战策略或个人影响力是独一无二的资产。我们将通过量身定制的品牌联动、全渠道内容分发及联合营销，实现个人品牌价值与商业价值的双重提升。
                                </div>
                            </div>
                            <div class="s3wordItem">
                                <div class="s3Title title-32_bold md-subtitle-20_medium">社交媒体</div>
                                <div class="s3Desc secondary-black body-14_regular md-content-14_regular">
                                    为您活跃的社交阵地，持续供给高相关性、高互动性的优质内容与创意活动。我们将提供与您账号风格契合的图文、视频素材及热点活动，助您高效提升粉丝粘性与互动数据，轻松维系平台活力。
                                </div>
                            </div>
                            <div class="s3wordItem">
                                <div class="s3Title title-32_bold md-subtitle-20_medium">其他</div>
                                <div class="s3Desc secondary-black body-14_regular md-content-14_regular">
                                    如果您从事上述未描述的其他金融市场活动的伙伴，我们极具开放性与灵活性，期待与您共同探索独一无二的共赢路径。
                                </div>
                            </div>
                        </div>
                        <div class="s3NavigatePart flex justify-between items-center">
                            <div class="s3Navigate flex items-center">
                                <div class="active"></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div class="s3NavigateBtn flex">
                                <div>
                                    <svg class="s3Prev cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="48"
                                        height="48" viewBox="0 0 48 48" fill="none">
                                        <path
                                            d="M24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44Z"
                                            stroke="black" stroke-linejoin="round" />
                                        <path d="M27 31L20 24L27 17" stroke="black" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <svg class="s3Next cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="48"
                                        height="48" viewBox="0 0 48 48" fill="none">
                                        <path
                                            d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
                                            stroke="black" stroke-linejoin="round" />
                                        <path d="M21 31L28 24L21 17" stroke="black" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="affPro-section6">
            <h2 class="title-40_bold md-subtitle-20_bold text-center scroll-fade-up">真实案例与内容精选</h2>
            <div class="aff6List flex scroll-fade-up">

                <div class="aff6Item">
                    <video class="lazyload" src="@/assets/image/partner2/s6Model2.mp4" muted autoplay loop></video>
                    <div
                        class="aff6Title cursor-pointer flex items-center justify-between subtitle-20_medium md-subtitle-18_medium">
                        <span>2000+全球研讨会</span>
                    </div>
                    <div class="content-14_regular md-content-14_regular secondary-black">
                        2000+全球线上研讨会，并持续更新中，直击精华内容，汲取全球顶尖思维，洞悉国际视野下的交易趋势与策略演变。</div>

                </div>
                <div class="aff6Item">
                    <img class="lazyload" decoding="async" src="@/assets/image/partner2/s6Model3.webp" alt="">
                    <a href="/activity"
                        class="aff6Title cursor-pointer flex items-center justify-between subtitle-20_medium md-subtitle-18_medium">
                        <span>线下活动</span>
                        <span class="iconfont icon-right"></span>
                    </a>
                    <div class="content-14_regular md-content-14_regular secondary-black">
                        回顾我们主办的各类线下峰会、沙龙与交流活动现场。构建更强的情感链接与长期信任，实现社群与品牌价值的双重沉淀。</div>

                </div>
                <div class="aff6Item">
                    <video class="lazyload" src="@/assets/image/partner2/s6Model4.mp4" muted autoplay loop></video>
                    <a href="/jinrong"
                        class="aff6Title cursor-pointer flex items-center justify-between subtitle-20_medium md-subtitle-18_medium">
                        <span>交易学院</span>
                        <span class="iconfont icon-right"></span>
                    </a>
                    <div class="content-14_regular md-content-14_regular secondary-black">
                        汇聚全球顶尖金融名师与资深交易专家，通过每日深度市场解析、系统化在线课程与权威交易期刊，提供您交易之路上所需的一切帮助。</div>

                </div>
                <div class="aff6Item">
                    <img class="lazyload" decoding="async" src="@/assets/image/partner2/s6Model1.webp" alt="">
                    <div
                        class="aff6Title cursor-pointer flex items-center justify-between subtitle-20_medium md-subtitle-18_medium">
                        <span>赋能伙伴，携手共赢</span>
                    </div>
                    <div class="content-14_regular md-content-14_regular secondary-black">
                        我们与全球众合作伙伴携手同行，通过全方位支持体系、创新工具与高竞争力方案，助力其拓展客户规模、提升服务价值与实现收入增长。</div>
                </div>
            </div>
            <div class="aff6ListPageNavigate">
                <span>
                    <svg class="aff6Prev disabled" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                        viewBox="0 0 48 48" fill="none">
                        <path
                            d="M24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44Z"
                            stroke="black" stroke-opacity="0.24" stroke-linejoin="round" />
                        <path d="M27 31L20 24L27 17" stroke="black" stroke-opacity="0.24" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
                <span style="margin-left: 10px;">
                    <svg class="aff6Next" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"
                        fill="none">
                        <path
                            d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
                            stroke="black" stroke-opacity="0.24" stroke-linejoin="round" />
                        <path d="M21 31L28 24L21 17" stroke="black" stroke-width="2" stroke-linecap="round"
                            stroke-opacity="0.24" stroke-linejoin="round" />
                    </svg>
                </span>

            </div>
        </div>
        <div class="s7Card-overlay"></div>
        <div class="affPro-section7 pc">
            <div class="contentBox">
                <h2 class="title-40_bold md-subtitle-20_bold scroll-fade-up text-center">EBC 精英成员</h2>
                <div class="s7CardList flex justify-between items-stretch flex-wrap">
                    <div class="s7Card-cardWrapper">
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s7Model1.webp" alt="">
                    </div>
                    <div class="s7Card-cardWrapper flex justify-center flex-col items-start">
                        <div class="title-32_medium">乔尔.帝纳波利</div>
                        <div class="topCardJob">
                            <span>斐波那契技术传奇教父</span> · <span>帝纳波利点位法创始人</span> · <span>黄金比率应用头号权威</span>
                        </div>
                        <div class="splitLine"></div>
                        <div class="topCardDesc content-14_regular secondary-white">Joe
                            DiNapoli拥有55年市场经验，曾预测1987年道指大跌和2002年市场底部等周期性拐点，在全球享有盛誉。作为一名注册商品交易顾问（CTA）超过25年，撰写了《帝纳波利点位交易法（DiNapoli
                            Levels）》，该书已被翻译成13种语言，风靡全球。</div>
                             <a href="/DiNapoli" class="flex items-center">
            <span class="content-14_regular">了解更多</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.07485 14.9592C6.82194 15.1941 6.80713 15.5896 7.04189 15.8426C7.27673 16.0955 7.67232 16.1103 7.92527 15.8756L13.7586 10.4589C13.886 10.3406 13.9584 10.1745 13.9584 10.0007C13.9584 9.82693 13.886 9.66081 13.7586 9.54255L7.92527 4.12588L7.87644 4.08478C7.62372 3.89378 7.26209 3.9217 7.04189 4.15884C6.82181 4.39598 6.82096 4.75838 7.03009 4.99624L7.07485 5.04222L12.4146 10.0007L7.07485 14.9592Z" fill="#fff"/>
            </svg>
          </a>
                    </div>
                    <div class="s7Card-cardWrapper">
                        <div class="s7Card-card">
                            <div class="s7Card-front">
                                <div class="imageCard">
                                    <img class="lazyload" decoding="async"
                                        src="@/assets/image/partner2/s7Model2.webp" alt="">
                                    <div class="openIcon">
                                        <img src="@/assets/image/partner2/s7IconOpen.svg" alt="">
                                    </div>
                                </div>
                                <div class="s7CardName subtitle-18_regular">Jason Zeng</div>
                            </div>
                            <div class="s7Card-back">
                                <div class="backContainer flex items-start">
                                    <img class="closeIcon" src="@/assets/image/partner2/icon-close.svg" alt="">
                                    <div class="backPhoto">
                                        <img class="lazyload" decoding="async"
                                            src="@/assets/image/partner2/s7Model2B.webp" alt="">
                                    </div>
                                    <div class="backWord">
                                        <div class="topName title-32_bold">
                                            Jason Zeng
                                        </div>
                                        <div class="splitLine"></div>
                                        <div class="bottomDesc content-14_regular secondary-black">Jason
                                            Zeng黄金率交易大师，美国布莱特期货基金合伙人，美国黄金率投资咨询有限公司总经理，美国纽约金融学院北京分院和芝加哥期货交易所特邀讲师，期货日报全国实盘大赛金牌导师，中文版«帝纳波利点位交易法»一书译者。作为全球帝纳波利点位交易法资深专家，自2008年以来成功预测上证指数几乎所有的转折点，以及美国道琼斯指数、美元指数、美国原油和黄金期货的多个阶段性顶部和底部。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="s7Card-cardWrapper">
                        <div class="s7Card-card">
                            <div class="s7Card-front">
                                <div class="imageCard">
                                    <img class="lazyload" decoding="async"
                                        src="@/assets/image/partner2/s7Model3.webp" alt="">
                                    <div class="openIcon">
                                        <img src="@/assets/image/partner2/s7IconOpen.svg" alt="">
                                    </div>
                                </div>
                                <div class="s7CardName subtitle-18_regular">Pieter van Wyk</div>
                            </div>
                            <div class="s7Card-back">
                                <div class="backContainer flex items-start">
                                    <img class="closeIcon" src="@/assets/image/partner2/icon-close.svg" alt="">
                                    <div class="backPhoto">
                                        <img class="lazyload" decoding="async"
                                            src="@/assets/image/partner2/s7Model3B.webp" alt="">
                                    </div>
                                    <div class="backWord">
                                        <div class="topName title-32_bold">
                                            Pieter van Wyk
                                        </div>
                                        <div class="splitLine"></div>
                                        <div class="bottomDesc content-14_regular secondary-black">
                                            Pieter对于交易浓厚的兴趣，始于高中时期。作为一名荣获优等生荣誉的经济学家，他在一家南非本土公司开启了全职交易的生涯，并广泛涉足于各类市场。自2003年起，他开始深入学习帝纳波利理论，并于2009年开始在全球范围内传授帝纳波利点位法。目前，他管理自己的账户，担任南非一家对冲基金的成员，并为南非的商品公司提供咨询服务。Pieter还是《D-Levels金融预测》新闻资讯的作者，他将自己的大部分成就归功于乔尔·帝纳波利的悉心指导。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="s7Card-cardWrapper">
                        <div class="s7Card-card">
                            <div class="s7Card-front">
                                <div class="imageCard">
                                    <img class="lazyload" decoding="async"
                                        src="@/assets/image/partner2/s7Model4.webp?t=1" alt="">
                                    <div class="openIcon">
                                        <img src="@/assets/image/partner2/s7IconOpen.svg" alt="">
                                    </div>
                                </div>
                                <div class="s7CardName subtitle-18_regular">Monchai Kongthanapakdi</div>
                            </div>
                            <div class="s7Card-back">
                                <div class="backContainer flex items-start">
                                    <img class="closeIcon" src="@/assets/image/partner2/icon-close.svg" alt="">
                                    <div class="backPhoto">
                                        <img class="lazyload" decoding="async"
                                            src="@/assets/image/partner2/s7Model5B.webp" alt="">
                                    </div>
                                    <div class="backWord">
                                        <div class="topName title-32_bold">
                                            Monchai <br />Kongthanapakdi
                                        </div>
                                        <div class="splitLine"></div>
                                        <div class="bottomDesc content-14_regular secondary-black">
                                            Monchai
                                            Kongthanapakdi是泰国技术分析师协会的创始人，也是CMT协会泰国分会的联合主席，并担任Efuturesthai交易学院院长，该学院旨在为泰国投资者提供技术分析和培训。Monchai是一名全职交易员、技术分析师和投资者，擅长斐波那契分析（DiNapoli
                                            Levels）和算法交易。自2011年起，Monchai与帝纳波利合作，在泰国举办了多场公开和私人研讨会，并参与了2022年《帝纳波利点位交易法》（泰文版）的翻译工作。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="s7Card-cardWrapper">
                        <div class="s7Card-card">
                            <div class="s7Card-front">
                                <div class="imageCard">
                                    <img class="lazyload" decoding="async"
                                        src="@/assets/image/partner2/s7Model5.webp" alt="">
                                    <div class="openIcon">
                                        <img src="@/assets/image/partner2/s7IconOpen.svg" alt="">
                                    </div>
                                </div>
                                <div class="s7CardName subtitle-18_regular">Lawrence Smart</div>
                            </div>
                            <div class="s7Card-back">
                                <div class="backContainer flex items-start">
                                    <img class="closeIcon" src="@/assets/image/partner2/icon-close.svg" alt="">
                                    <div class="backPhoto">
                                        <img class="lazyload" decoding="async"
                                            src="@/assets/image/partner2/s7Model4B.webp" alt="">
                                    </div>
                                    <div class="backWord">
                                        <div class="topName title-32_bold">
                                            Lawrence Smart
                                        </div>
                                        <div class="splitLine"></div>
                                        <div class="bottomDesc content-14_regular secondary-black">
                                            Lawrence拥有商业建筑行业背景，之后转型进入金融市场，以追求一个更有成就感的职业发展。在发现DiNapoli
                                            Levels后，他的交易方式发生了转变。自从17年前于泰国曼谷参加帝纳波利研讨会以来，Lawrence多次准确预测市场走势，包括应对新冠疫情引发的市场崩盘。目前，作为一名帝纳波利交易法专家，他指导新交易者规避陷阱，加快他们的学习进程。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <div class="affPro-section7 mobile">
            <h2 class="scroll-fade-up subtitle-20_bold">EBC 精英成员</h2>
             <a href="/DiNapoli" class="flex items-center scroll-fade-up">
            <span class="content-14_regular">了解更多</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.07485 14.9592C6.82194 15.1941 6.80713 15.5896 7.04189 15.8426C7.27673 16.0955 7.67232 16.1103 7.92527 15.8756L13.7586 10.4589C13.886 10.3406 13.9584 10.1745 13.9584 10.0007C13.9584 9.82693 13.886 9.66081 13.7586 9.54255L7.92527 4.12588L7.87644 4.08478C7.62372 3.89378 7.26209 3.9217 7.04189 4.15884C6.82181 4.39598 6.82096 4.75838 7.03009 4.99624L7.07485 5.04222L12.4146 10.0007L7.07485 14.9592Z" fill="#fff"/>
            </svg>
          </a>
            <div class="memberList flex">
                <div class="memberItem">
                    <div class="photoPart">
                        <div class="openIcon">
                            <img src="@/assets/image/partner2/s7IconOpen.svg" alt="">
                        </div>
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s7Model1M.webp" alt="">

                    </div>
                    <div class="memberName md-body-14_regular">乔尔.帝纳波利</div>
                </div>
                <div class="memberItem">
                    <div class="photoPart">
                        <div class="openIcon">
                            <img src="@/assets/image/partner2/s7IconOpen.svg" alt="">
                        </div>
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s7Model2M.webp" alt="">

                    </div>
                    <div class="memberName md-body-14_regular">Jason Zeng</div>
                </div>
                <div class="memberItem">
                    <div class="photoPart">
                        <div class="openIcon">
                            <img src="@/assets/image/partner2/s7IconOpen.svg" alt="">
                        </div>
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s7Model3M.webp" alt="">

                    </div>
                    <div class="memberName md-body-14_regular">Pieter van Wyk</div>
                </div>
                <div class="memberItem">
                    <div class="photoPart">
                        <div class="openIcon">
                            <img src="@/assets/image/partner2/s7IconOpen.svg" alt="">
                        </div>
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s7Model4M.webp" alt="">

                    </div>
                    <div class="memberName md-body-14_regular">Lawrence Smart</div>
                </div>
                <div class="memberItem">
                    <div class="photoPart">
                        <div class="openIcon">
                            <img src="@/assets/image/partner2/s7IconOpen.svg" alt="">
                        </div>
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s7Model5M.webp" alt="">

                    </div>
                    <div class="memberName md-body-14_regular">Monchai Kongthanapakdi</div>
                </div>
            </div>
        </div>
        <div class="mobile">
            <div class="s7Dial ">
                <img class="closeIcon" src="@/assets/image/partner2/closeIconW.svg" alt="">
                <div class="DialItem">
                    <div class="topImg">
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s7Model1M.webp" alt="">
                    </div>
                    <div class="bottomWord">
                        <div class="memName">乔尔.帝纳波利</div>
                        <div class="memJob">· <span>斐波那契技术传奇教父</span></div>
                        <div class="memJob">· <span>帝纳波利点位法创始人</span></div>
                        <div class="memJob">· <span>黄金比率应用头号权威</span></div>
                        <div class="memDesc secondary-black">
                            Joe
                            DiNapoli拥有55年市场经验，曾预测1987年道指大跌和2002年市场底部等周期性拐点，在全球享有盛誉。作为一名注册商品交易顾问（CTA）超过25年，撰写了《帝纳波利点位交易法（DiNapoli
                            Levels）》，该书已被翻译成13种语言，风靡全球。
                        </div>
                    </div>
                </div>
                <div class="DialItem">
                    <div class="topImg">
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s7Model2M.webp" alt="">
                    </div>
                    <div class="bottomWord">
                        <div class="memName">Jason Zeng</div>
                        <div class="memDesc secondary-black">Jason
                            Zeng黄金率交易大师，美国布莱特期货基金合伙人，美国黄金率投资咨询有限公司总经理，美国纽约金融学院北京分院和芝加哥期货交易所特邀讲师，期货日报全国实盘大赛金牌导师，中文版«帝纳波利点位交易法»一书译者。作为全球帝纳波利点位交易法资深专家，自2008年以来成功预测上证指数几乎所有的转折点，以及美国道琼斯指数、美元指数、美国原油和黄金期货的多个阶段性顶部和底部。
                        </div>
                    </div>
                </div>
                <div class="DialItem">
                    <div class="topImg">
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s7Model3M.webp" alt="">
                    </div>
                    <div class="bottomWord">
                        <div class="memName">Pieter van Wyk</div>
                        <div class="memDesc secondary-black">
                            Pieter对于交易浓厚的兴趣，始于高中时期。作为一名荣获优等生荣誉的经济学家，他在一家南非本土公司开启了全职交易的生涯，并广泛涉足于各类市场。自2003年起，他开始深入学习帝纳波利理论，并于2009年开始在全球范围内传授帝纳波利点位法。目前，他管理自己的账户，担任南非一家对冲基金的成员，并为南非的商品公司提供咨询服务。Pieter还是《D-Levels金融预测》新闻资讯的作者，他将自己的大部分成就归功于乔尔·帝纳波利的悉心指导。
                        </div>
                    </div>
                </div>
                <div class="DialItem">
                    <div class="topImg">
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s7Model4M.webp" alt="">
                    </div>
                    <div class="bottomWord">
                        <div class="memName">Lawrence Smart</div>

                        <div class="memDesc secondary-black">
                            Lawrence拥有商业建筑行业背景，之后转型进入金融市场，以追求一个更有成就感的职业发展。在发现DiNapoli
                            Levels后，他的交易方式发生了转变。自从17年前于泰国曼谷参加帝纳波利研讨会以来，Lawrence多次准确预测市场走势，包括应对新冠疫情引发的市场崩盘。目前，作为一名帝纳波利交易法专家，他指导新交易者规避陷阱，加快他们的学习进程。
                        </div>
                    </div>
                </div>
                <div class="DialItem">
                    <div class="topImg">
                        <img class="lazyload" decoding="async" src="@/assets/image/partner2/s7Model5M.webp" alt="">
                    </div>
                    <div class="bottomWord">
                        <div class="memName">Monchai<br /> Kongthanapakdi</div>

                        <div class="memDesc secondary-black">
                            Monchai
                            Kongthanapakdi是泰国技术分析师协会的创始人，也是CMT协会泰国分会的联合主席，并担任Efuturesthai交易学院院长，该学院旨在为泰国投资者提供技术分析和培训。Monchai是一名全职交易员、技术分析师和投资者，擅长斐波那契分析（DiNapoli
                            Levels）和算法交易。自2011年起，Monchai与帝纳波利合作，在泰国举办了多场公开和私人研讨会，并参与了2022年《帝纳波利点位交易法》（泰文版）的翻译工作。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="affPro-section8">
            <div class="contentBox">
                <h2 class="title-40_bold md-subtitle-20_bold scroll-fade-up text-center">全球伙伴的真实声音</h2>
                <div class="aff8SwiperList flex scroll-fade-up items-start justify-between">
                    <div class="aff8Left">
                        <img class="lazyload largeImg" decoding="async" src="@/assets/image/partner2/s8lModel.webp"
                            alt="">
                        <div class="s8Left-stack" id="stack" aria-label="avatars">
                            <img class="s8Left-avatar" src="@/assets/image/partner2/s8sLogo1.png" alt="avatar 1" />
                            <img class="s8Left-avatar" src="@/assets/image/partner2/s8sLogo2.png" alt="avatar 2" />
                            <img class="s8Left-avatar" src="@/assets/image/partner2/s8sLogo3.png" alt="avatar 3" />
                            <img class="s8Left-avatar" src="@/assets/image/partner2/s8sLogo4.png" alt="avatar 4" />
                            <img class="s8Left-avatar" src="@/assets/image/partner2/s8sLogo5.png" alt="avatar 5" />
                            <img class="s8Left-avatar" src="@/assets/image/partner2/s8sLogo6.png" alt="avatar 6" />
                            <img class="s8Left-avatar" src="@/assets/image/partner2/s8sLogo7.png" alt="avatar 7" />
                        </div>
                    </div>
                    <div class=" swiper s8Swiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide aff8Right">
                                <img class="lazyload topIcon pc" decoding="async"
                                    src="@/assets/image/partner2/s8RIcon.svg" alt="">
                                <img class="lazyload topIcon mobile" decoding="async"
                                    src="@/assets/image/partner2/s8Stars.png" alt="">
                                <div class="aff8Word">
                                    最初选择
                                    EBC，是因为佣金结构清晰、结算节奏稳定，合作对账也更省心。真正跑起来后更能感受到执行体验比较稳，即使在波动行情里客户的成交反馈也更好。这种对交易细节和流程透明度的坚持，让我更放心长期做业务。
                                </div>
                                <div class="aff8Intro flex justify-between items-center">
                                    <div class="introL flex items-center">
                                        <div class="introHeader">E</div>
                                        <div>
                                            <div class="introName subtitle-20_regular">Evan</div>
                                            <div class="body-16_regular secondary-black">资深IB</div>
                                        </div>
                                    </div>
                                    <div class="introR">
                                        <img class="lazyload pc" decoding="async"
                                            src="@/assets/image/partner2/s8Stars.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide aff8Right">

                                <img class="lazyload topIcon pc" decoding="async"
                                    src="@/assets/image/partner2/s8RIcon.svg" alt="">
                                <img class="lazyload topIcon mobile" decoding="async"
                                    src="@/assets/image/partner2/s8Stars.png" alt="">
                                <div class="aff8Word">
                                    作为成长中的 IB，我们最需要的是后台数据清楚、支持响应及时。EBC
                                    的对接效率超出预期，客户的问题能更快拿到专业解答，处理链路也更顺。这直接提升了我们的服务口碑，也让客户更愿意长期留在平台。
                                </div>
                                <div class="aff8Intro flex justify-between items-center">
                                    <div class="introL flex items-center">
                                        <div class="introHeader">M</div>
                                        <div>
                                            <div class="introName subtitle-20_regular">Mason</div>
                                            <div class="body-16_regular secondary-black">IB团队负责人</div>
                                        </div>
                                    </div>
                                    <div class="introR">
                                        <img class="lazyload pc" decoding="async"
                                            src="@/assets/image/partner2/s8Stars.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide aff8Right">
                                <img class="lazyload topIcon pc" decoding="async"
                                    src="@/assets/image/partner2/s8RIcon.svg" alt="">
                                <img class="lazyload topIcon mobile" decoding="async"
                                    src="@/assets/image/partner2/s8Stars.png" alt="">

                                <div class="aff8Word">
                                    与 EBC
                                    的合作不只是把流量导过去，而是平台能提供更完整的品牌素材和内容支持，让我们的推广更“像一个专业机构在讲产品”。更重要的是对接团队反馈快、沟通顺，很多细节能一起磨到位，合作更像伙伴而不是一次性投放。
                                </div>
                                <div class="aff8Intro flex justify-between items-center">
                                    <div class="introL flex items-center">
                                        <div class="introHeader">N</div>
                                        <div>
                                            <div class="introName subtitle-20_regular">Nina</div>
                                            <div class="body-16_regular secondary-black">联盟推广负责人</div>
                                        </div>
                                    </div>
                                    <div class="introR">
                                        <img class="lazyload pc" decoding="async"
                                            src="@/assets/image/partner2/s8Stars.png" alt="">
                                    </div>
                                </div>
                            </div>

                            <div class="swiper-slide aff8Right">
                                <img class="lazyload topIcon pc" decoding="async"
                                    src="@/assets/image/partner2/s8RIcon.svg" alt="">
                                <img class="lazyload topIcon mobile" decoding="async"
                                    src="@/assets/image/partner2/s8Stars.png" alt="">

                                <div class="aff8Word">
                                    合作前最担心规则不清楚、后期对账扯皮。EBC 的佣金口径和结算逻辑写得比较明白，数据也更透明，减少了很多不必要的沟通成本。我们也更愿意把高质量用户导向
                                    EBC，因为长期合作更重要的是稳定和可持续。
                                </div>
                                <div class="aff8Intro flex justify-between items-center">
                                    <div class="introL flex items-center">
                                        <div class="introHeader">S</div>
                                        <div>
                                            <div class="introName subtitle-20_regular">Sophie</div>
                                            <div class="body-16_regular secondary-black">渠道运营负责人</div>
                                        </div>
                                    </div>
                                    <div class="introR">
                                        <img class="lazyload pc" decoding="async"
                                            src="@/assets/image/partner2/s8Stars.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide aff8Right">
                                <img class="lazyload topIcon pc" decoding="async"
                                    src="@/assets/image/partner2/s8RIcon.svg" alt="">
                                <img class="lazyload topIcon mobile" decoding="async"
                                    src="@/assets/image/partner2/s8Stars.png" alt="">

                                <div class="aff8Word">
                                    我们选择合作方一直很谨慎，因为社群信任来之不易。EBC
                                    没有一上来就强推转化，而是先做内容共建和社群互动，把节奏放在长期价值上。等信任建立后，再去做课程、活动或产品承接，转化反而更自然，也更健康。
                                </div>
                                <div class="aff8Intro flex justify-between items-center">
                                    <div class="introL flex items-center">
                                        <div class="introHeader">N</div>
                                        <div>
                                            <div class="introName subtitle-20_regular">Noah</div>
                                            <div class="body-16_regular secondary-black">社群主理人</div>
                                        </div>
                                    </div>
                                    <div class="introR">
                                        <img class="lazyload pc" decoding="async"
                                            src="@/assets/image/partner2/s8Stars.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide aff8Right">
                                <img class="lazyload topIcon pc" decoding="async"
                                    src="@/assets/image/partner2/s8RIcon.svg" alt="">
                                <img class="lazyload topIcon mobile" decoding="async"
                                    src="@/assets/image/partner2/s8Stars.png" alt="">

                                <div class="aff8Word">
                                    与 EBC
                                    合作后，我的内容不只是输出观点，还能借助平台的工具与培训体系，把方法论更系统地呈现给用户。共创过程中还能接触不同市场视角，反过来促进我持续迭代自己的交易框架。对策略型创作者来说，这种“资源支持加共同成长”比短期曝光更有价值。
                                </div>
                                <div class="aff8Intro flex justify-between items-center">
                                    <div class="introL flex items-center">
                                        <div class="introHeader">L</div>
                                        <div>
                                            <div class="introName subtitle-20_regular">Leo</div>
                                            <div class="body-16_regular secondary-black">专业交易者</div>
                                        </div>
                                    </div>
                                    <div class="introR">
                                        <img class="lazyload pc" decoding="async"
                                            src="@/assets/image/partner2/s8Stars.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="s8Navigate flex justify-center scroll-fade-up">
                    <div class="active"></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <message-v3></message-v3>

        <page-footer></page-footer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import fadeAnimate from "../mixins/fadeAnimate.js";

import 'swiper/css/swiper.css'
import Swiper from 'swiper'
import {
    mapState,
} from 'vuex'
export default {
    mixins: [fadeAnimate],
    computed: {
        ...mapGetters([
            'signupUrl',
        ])
    },
    mounted() {
        document.documentElement.setAttribute("data-theme", "dark");
        this.initPage()
    },
 
    methods: {
        initPage() {
            const isMobile = window.matchMedia("(max-width:996px)").matches;

            function numberAnimate() {
                console.log("numberAn");
                const cfg = {
                    1: [125, 0, "12.5K+"],
                    2: [50, 0, "50+"],
                    3: [31, 0, "$3.1M+"],
                    4: [100, 0, "100+"],
                };

                Object.keys(cfg).forEach((key) => {
                    const [end, decimals, prefix] = cfg[key];
                    const $el = $(
                        `.affPro-headerContent div:nth-child(${key}) .affPro-headerNum`,
                    );
                    $({ countNum: decimals === 1 ? 60 : 0 }).animate(
                        { countNum: end },
                        {
                            duration: 1500,
                            easing: "linear",
                            step() {
                                const val =
                                    decimals > 0
                                        ? (this.countNum / 10).toFixed(1)
                                        : Math.floor(this.countNum);
                                $el.eq(0).text(val);
                            },
                            complete() {
                                const final = prefix;
                                $el.eq(0).text(final);
                            },
                        },
                    );
                });
            }

            (function () {
                const mobileSection2DataList = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((e) => {
                            if (e.isIntersecting) {
                                numberAnimate();
                                mobileSection2DataList.disconnect(e.target);
                            }
                        });
                    },
                    { threshold: 0.5 },
                );
                mobileSection2DataList.observe(document.querySelector(".affPro-header"));
            })();

            let s2CardAct = 0;
            let s2CardList = document.querySelectorAll(".affPro-section3Card");
            s2CardList.forEach((card, index) => {
                isMobile && card.classList.add("active");
                !isMobile &&
                    card.addEventListener("mouseenter", () => {
                        if (index != s2CardAct) {
                            s2CardList[s2CardAct].classList.remove("active");
                            s2CardList[index].classList.add("active");
                            s2CardAct = index;
                        }
                    });
            });

            let s3Act = 0;
            let s3WordList = document.querySelectorAll(".s3wordItem");
            let s3NavigateDiv = document.querySelectorAll(".s3Navigate div");
            const s3swiper = new Swiper(".s3Swiper", {
                slidesPerView: 1,
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                spaceBetween: 20,
                on: {
                    slideChange() {
                        console.log("realIndex:", this.realIndex);
                        s3WordList[s3Act].classList.remove("active");
                        s3NavigateDiv[s3Act].classList.remove("active");
                        s3WordList[this.realIndex].classList.add("active");
                        s3NavigateDiv[this.realIndex].classList.add("active");
                        s3Act = this.realIndex;
                    },
                },
            });

            document.querySelectorAll(".s3NavigateBtn svg").forEach((i, idx) => {
                i.addEventListener("click", () => {
                    console.log(idx);
                    idx == 0 && s3swiper.slidePrev();
                    idx == 1 && s3swiper.slideNext();
                });
            });
            let s4Act = 0;
            let s4NavigateDiv = document.querySelectorAll(".s4Navigate div");
            isMobile &&
                new Swiper(".s4Swiper", {
                    slidesPerView: 1,
                    loop: true,
                    centeredSlides: true,
                    spaceBetween: 20,

                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    on: {
                        slideChange() {
                            s4NavigateDiv[s4Act].classList.remove("active");
                            s4NavigateDiv[this.realIndex].classList.add("active");
                            s4Act = this.realIndex;
                        },
                    },
                });
            const isRTL = location.href.includes('/ar/');

            function checkScrollExtreme(dom = document.querySelector(".aff6List")) {
                const { scrollLeft, scrollWidth, clientWidth } = dom;

                // 在 RTL 下，scrollLeft 为负，0 表示最右侧（“开头”）
                const maxScroll = scrollWidth - clientWidth;   // 正数
                const current = Math.abs(scrollLeft);          // 取绝对值比较

                const result = {
                    isStart: current <= 1,                       // 开头（LTR=最左，RTL=最右）
                    isEnd: Math.abs(current - maxScroll) <= 1    // 结尾（LTR=最右，RTL=最左）
                };

                // 更新按钮状态
                $(".aff6Prev").toggleClass("disabled", result.isStart);
                $(".aff6Next").toggleClass("disabled", result.isEnd);
            }

            const moveDistance = isMobile ? 300 : 500;

            $(".aff6Prev").on("click", () => {
                // 向“开头”滚一格
                const delta = isRTL ? moveDistance : -moveDistance;
                $(".aff6List").animate({ scrollLeft: `+=${delta}` }, 200, checkScrollExtreme);
            });

            $(".aff6Next").on("click", () => {
                // 向“结尾”滚一格
                const delta = isRTL ? -moveDistance : moveDistance;
                $(".aff6List").animate({ scrollLeft: `+=${delta}` }, 200, checkScrollExtreme);
            });
            function onDragEnd(el, cb) {
                let moved = false;
                el.addEventListener("touchstart", () => (moved = false), { passive: true });
                el.addEventListener("touchmove", () => (moved = true), { passive: false });
                el.addEventListener(
                    "touchend",
                    (e) => {
                        if (moved) cb(e);
                    },
                    { passive: true },
                );
            }
            isMobile &&
                onDragEnd(document.querySelector(".aff6List"), (e) => {
                    setTimeout(() => {
                        checkScrollExtreme();
                    }, 500);
                });
            let s8Act = 0;
            let s8NavigateDiv = document.querySelectorAll(".s8Navigate div");

            let s8Swiper = new Swiper(".s8Swiper", {
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                slidesPerView: 1,
                spaceBetween: 20,
                on: {
                    slideChange() {
                        s8NavigateDiv[s8Act].classList.remove("active");
                        s8NavigateDiv[this.realIndex].classList.add("active");
                        s8Act = this.realIndex;
                    },
                },
            });
            s8NavigateDiv.forEach((i, idx) => {
                i.addEventListener("click", () => {
                    s8Swiper.slideToLoop(idx);
                });
            });

            const stack = document.getElementById("stack");
            let s8LeftIsAnimating = false;
            let s8LeftAnimTimer = null;

            function s8LeftParseMs(value) {
                const v = String(value || "").trim();
                if (!v) return 0;
                if (v.endsWith("ms")) return Number.parseFloat(v);
                if (v.endsWith("s")) return Number.parseFloat(v) * 1000;
                const n = Number.parseFloat(v);
                return Number.isFinite(n) ? n : 0;
            }
            function setZIndex() {
                const items = Array.from(stack.children);
                items.forEach((el, i) => {
                    // 右边（DOM 越靠后）越在上层
                    el.style.zIndex = String(i + 1);
                });
            }
            function getRects() {
                const items = Array.from(stack.children);
                const map = new Map();
                for (const el of items) map.set(el, el.getBoundingClientRect());
                return map;
            }

            function rotateRightWithFlip() {
                if (s8LeftIsAnimating) return;
                const items = Array.from(stack.children);
                if (items.length <= 1) return;

                const firstRects = getRects();
                const last = items[items.length - 1];
                stack.insertBefore(last, items[0]);
                setZIndex();

                const lastRects = getRects();

                // 4) Invert (apply delta instantly, no transition)
                for (const el of Array.from(stack.children)) {
                    const a = firstRects.get(el);
                    const b = lastRects.get(el);
                    if (!a || !b) continue;
                    const dx = a.left - b.left;
                    const dy = a.top - b.top;
                    el.style.transition = "none";
                    el.style.transform = `translate3d(${dx}px, ${dy}px, 0)`;
                }

                // 关键：强制 reflow，避免移动端把样式变更合并导致“瞬移”
                stack.getBoundingClientRect();

                // 5) Play (animate to transform: none) —— 双 rAF 更稳（尤其 iOS Safari）
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        s8LeftIsAnimating = true;
                        for (const el of Array.from(stack.children)) {
                            el.style.transition = `transform var(--speed) cubic-bezier(.2,.8,.2,1)`;
                            el.style.transform = "translate3d(0px, 0px, 0)";
                        }

                        const speedMs = s8LeftParseMs(
                            getComputedStyle(document.documentElement).getPropertyValue("--speed"),
                        );
                        if (s8LeftAnimTimer) clearTimeout(s8LeftAnimTimer);
                        s8LeftAnimTimer = setTimeout(
                            () => {
                                s8LeftIsAnimating = false;
                                s8LeftAnimTimer = null;
                            },
                            Math.max(0, speedMs) + 60,
                        );
                    });
                });
            }

            setZIndex();
            setInterval(() => rotateRightWithFlip(), 3000);

            !isMobile &&
                (() => {
                    const cardWrappers = document.querySelectorAll(".s7Card-cardWrapper");
                    const overlay = document.querySelector(".s7Card-overlay");

                    // 关闭所有卡片
                    function closeAll() {
                        overlay.classList.remove("active");
                        // document.body.style.overflow = "";

                        cardWrappers.forEach((wrapper) => {
                            if (!wrapper.classList.contains("is-expanded")) return;

                            const card = wrapper.querySelector(".s7Card-card");

                            // 无过渡，直接清除所有样式并恢复原状
                            card.style.cssText = "";

                            // 移除所有状态类
                            card.classList.remove(
                                "is-expanding",
                                "is-animating",
                                "is-center",
                                "is-animation-complete",
                            );
                            wrapper.classList.remove("is-flipped", "is-expanded");
                        });
                    }

                    // 打开卡片
                    function openCard(wrapper) {
                        // closeAll();

                        const card = wrapper.querySelector(".s7Card-card");

                        // 先翻转
                        wrapper.classList.add("is-flipped");

                        // 翻转完成后，开始移动到中心
                        setTimeout(() => {
                            // 获取当前位置
                            const rect = card.getBoundingClientRect();

                            // 1. 添加展开类（fixed 定位，无过渡）并设置初始位置
                            card.classList.add("is-expanding");
                            card.style.left = rect.left + "px";
                            card.style.top = rect.top + "px";
                            card.style.width = "282rem";
                            card.style.height = "323rem";
                            card.style.transform = "rotateY(180deg)";

                            // 2. 强制重排，确保初始位置生效
                            card.offsetHeight;

                            // 3. 下一帧：启用过渡并移动到中心
                            requestAnimationFrame(() => {
                                card.classList.add("is-animating", "is-center");

                                // 更新状态
                                wrapper.classList.add("is-expanded");
                                overlay.classList.add("active");
                                // document.body.style.overflow = "hidden";

                                // 等待动画完成后再允许内容溢出
                                setTimeout(() => {
                                    card.classList.add("is-animation-complete");
                                }, 300);
                            });
                        }, 300);
                    }

                    // 为每个卡片绑定事件
                    cardWrappers.forEach((wrapper) => {
                        const openBtn = wrapper.querySelector(".openIcon");
                        const closeBtn = wrapper.querySelector(".closeIcon");
                        if (!openBtn) return;
                        openBtn && openBtn.addEventListener("click", () => openCard(wrapper));
                        closeBtn && closeBtn.addEventListener("click", closeAll);
                    });
                    window.closeAll = closeAll;
                    // 点击遮罩关闭
                    overlay.addEventListener("click", closeAll);

                    // ESC 键关闭
                    document.addEventListener("keydown", (e) => {
                        if (e.key === "Escape") closeAll();
                    });
                })();

            let s7lastIndex = -1;
            isMobile &&
                document
                    .querySelectorAll(".affPro-section7.mobile .openIcon")
                    .forEach((el, index) => {
                        el.addEventListener("click", () => {
                            s7lastIndex > -1 &&
                                document
                                    .querySelectorAll(".s7Dial .DialItem")
                                [s7lastIndex].classList.remove("active");
                            document
                                .querySelectorAll(".s7Dial .DialItem")
                            [index].classList.add("active");
                            s7lastIndex = index;
                            document.querySelector(".s7Card-overlay").classList.add("active");
                            document.querySelector(".s7Dial").classList.add("active");
                        });
                    });

            document.querySelector(".s7Dial .closeIcon").addEventListener("click", () => {
                document.querySelector(".s7Card-overlay").classList.remove("active");
                document.querySelector(".s7Dial").classList.remove("active");
            });

            ibBtn.addEventListener("click", () => {
                const target = document.querySelector(".message-new ");
                target.scrollIntoView({ behavior: "smooth", block: "start" });
            });

            // document.querySelectorAll('.photoItem').forEach((el) => {
            //     el.addEventListener('click', () => {
            //         const result = location.href.replace('/affiliate-programmes', '/webinars/instructors').replace('/partners', '/webinars/instructors')
            //         location.href = result
            //     });
            // })

            document.querySelectorAll('.aff6Item').forEach((el) => {
                let url = ''
                let innerA = el.querySelector('.aff6Title')
                url = innerA.href
                innerA.addEventListener('click', () => {
                    e.preventDefault();
                })
                url && el.addEventListener('click', () => {
                    location.href = url
                });
            })
        }
    }
}

</script>

<style scoped>
.secondary-white {
    color: var(--ebc-text-secondary_white);
}

.secondary-black {
    color: var(--ebc-text-secondary);
}

a:hover {
    color: var(--ebc-text-primary_white);
}

.affPro-header {
    padding: 290rem 0 72rem;
    color: var(--ebc-text-primary_white);
    position: relative;
    background-color: #000;
    height: 900rem;
    background: transparent;
    box-sizing: border-box;
    overflow: hidden;
    flex-direction: column;
}

.affPro-header h1 {
    max-width: 1200rem;
    margin-inline: auto;
}

.affPro-header .bgImg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    z-index: -1;
    transition: transform 4s ease;
}

.affPro-header:hover .bgImg {
    transform: scale(1.2);
    transform-origin: center;
}

.affPro-header h1 {
    line-height: 100rem;
    font-size: 92rem;
}

.affPro-header h2 {
    margin: 24rem 0 64rem;
}

.affPro-headerContent {
    gap: 28rem;
}

.affPro-headerContent>div {
    flex: 0 0 230rem;
}

.affPro-headerContent .split {
    width: 0.5px;
    height: 40rem;
    background-color: rgba(255, 255, 255, 0.32);
    flex: 0 0 0.5px;
}

.affPro-header a {
    width: fit-content;
    min-width: 300rem;
    margin-inline: auto;
    gap: 5rem;
    background: var(--ebc-basecolor-active-400);
}

.affPro-header a:hover {
    background: var(--ebc-basecolor-active-500);

}

.affPro-headerContent .affPro-headerNum {
    color: var(--ebc-text-primary_white);
    font-size: 48rem;
    font-weight: 700;
    line-height: 56rem;
    margin-bottom: 4rem;
}

.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
    padding-block: 120rem;
}

@media (max-width: 996px) {
    .contentBox {
        max-width: 100%;
        padding: 80rem 32rem;
    }

    .affPro-header .bgImg {
        object-position: 35% top;
    }

    .affPro-header {
        padding: calc(222rem + 40px) 32rem 80rem;
        min-height: 1160rem;
        margin-top: -44px;
        height: auto;
    }

    .affPro-header h2 {
        margin-top: 16rem;
    }

    .affPro-header a {
        width: 100%;
    }

    .affPro-header .affPro-headerContent {
        flex-wrap: wrap;
        margin-top: 60rem;
        align-items: flex-start !important;
    }

    .affPro-headerContent div:nth-child(3) {
        order: 2;
    }

    .affPro-headerContent div:nth-child(2),
    .affPro-headerContent div:nth-child(4) {
        order: 3;
    }

    .affPro-headerContent>div {
        flex: 1;
        min-width: 40%;
    }

    .affPro-headerContent .affPro-headerNum {
        font-size: 56rem;
        line-height: 73rem;
    }
}

.affPro-section2 {
    background: linear-gradient(180deg, #16161a 0%, #2b2b33 100%);
    padding: 120rem 120rem 0;
}

.affPro-section2 h2 {
    color: var(--ebc-text-primary_white);
}

@media (min-width: 996px) {
    .affPro-section2 .photoList {
        display: grid !important;
        grid-template-columns: repeat(10, 1fr);
    }
}

.affPro-section2 .photoList {

    gap: 17rem;
    /* max-width: 1765rem; */
    margin-inline: auto;
}

.affPro-section2 .photoList .photoItem {
    /* flex: 1; */
    /* height: 160rem; */
    aspect-ratio: 1;
    overflow: hidden;
    border-radius: var(--ebc-corner-radius-rc16);
    transition: all 0.3s ease;
    cursor: pointer;
}

.photoItem.opa05 {
    opacity: 0.05;
}

.photoItem.opa1 {
    opacity: .1;
}

.photoItem.opa2 {
    opacity: .2;
}

.photoItem.opa3 {
    opacity: .3;
}

.photoItem.opa4 {
    opacity: .4;
}

.photoItem.opa5 {
    opacity: .5;
}

.photoItem.opa7 {
    opacity: .7;
}

.photoItem.blur2 {
    filter: blur(2px);
}

.photoItem.blur3 {
    filter: blur(3px);
}

.photoItem.blur5 {
    filter: blur(5px);
}

.affPro-section2 .photoItem:hover {
    filter: none !important;
}

.affPro-section2 .photoItem:hover.opa100 {
    opacity: 1;
}

.affPro-section2 .photoItem:hover.opa80 {
    opacity: 0.8;
}

.affPro-section2 .photoItem:hover.opa60 {
    opacity: 0.6;
}

.affPro-section2 .photoItem:hover.opa50 {
    opacity: 0.5;
}



.affPro-section2 .photoList .photoItem img {
    width: 100%;
    height: 100%;
    transition: transform 0.3s linear;
}

.affPro-section2 .photoList .photoItem:hover img {
    transform: scale(1.2);
}

.affPro-section2 .photoList .photoItem.bgc1 {
    background-color: #5d2333;
}

.affPro-section2 .photoList .photoItem.bgc2 {
    background-color: #e6ddcf;
}

.affPro-section2 .photoList .photoItem.bgc3 {
    background-color: #6a6967;
}

.affPro-section2 .photoList .photoItem.bgc4 {
    background-color: #f9f6f2;
}

.affPro-section2 .photoList .photoItem.bgc5 {
    background-color: #9f734c;
}

.affPro-section2 .photoList .photoItem.bgc6 {
    background-color: #ff4b4e;
}

.affPro-section2 a {
    width: fit-content;
    min-width: 160rem;
    margin: 56rem auto 80rem;
}

@media (max-width: 996px) {
    .affPro-section2 {
        padding: 80rem 32rem 0;
    }

    .affPro-section2 a {
        min-width: 270rem;
        height: 88rem;
        margin-block: 56rem 80rem;
        font-size: 28rem;
        line-height: 1;
    }

    .affPro-section2 .photoList {
        gap: 12rem;
    }

    .affPro-section2 .photoList .photoItem {
        border-radius: 12rem;
        flex: 0 0 159rem;
        height: 159rem;
        display: none;
    }

    .affPro-section2 .photoList .photoItem:nth-child(3),
    .affPro-section2 .photoList .photoItem:nth-child(4),
    .affPro-section2 .photoList .photoItem:nth-child(5),
    .affPro-section2 .photoList .photoItem:nth-child(6),
    .affPro-section2 .photoList .photoItem:nth-child(12),
    .affPro-section2 .photoList .photoItem:nth-child(14),
    .affPro-section2 .photoList .photoItem:nth-child(15),
    .affPro-section2 .photoList .photoItem:nth-child(17),
    .affPro-section2 .photoList .photoItem:nth-child(22),
    .affPro-section2 .photoList .photoItem:nth-child(23),
    .affPro-section2 .photoList .photoItem:nth-child(25),
    .affPro-section2 .photoList .photoItem:nth-child(26),
    .affPro-section2 .photoList .photoItem:nth-child(31),
    .affPro-section2 .photoList .photoItem:nth-child(32),
    .affPro-section2 .photoList .photoItem:nth-child(36),
    .affPro-section2 .photoList .photoItem:nth-child(37) {
        display: block;
    }

    .affPro-section2 .photoList .photoItem:nth-child(3),
    .affPro-section2 .photoList .photoItem:nth-child(7),
    .affPro-section2 .photoList .photoItem:nth-child(15),
    .affPro-section2 .photoList .photoItem:nth-child(22),
    .affPro-section2 .photoList .photoItem:nth-child(31),
    .affPro-section2 .photoList .photoItem:nth-child(38),
    .affPro-section2 .photoList .photoItem:nth-child(4) {
        filter: blur(1.17px);
    }

    .affPro-section2 .photoList .photoItem:nth-child(5),
    .affPro-section2 .photoList .photoItem:nth-child(23),
    .affPro-section2 .photoList .photoItem:nth-child(26),
    .affPro-section2 .photoList .photoItem:nth-child(13) {
        filter: blur(1.96px);
    }

    .affPro-section2 .photoList .photoItem:nth-child(12),
    .affPro-section2 .photoList .photoItem:nth-child(32),
    .affPro-section2 .photoList .photoItem:nth-child(36),
    .affPro-section2 .photoList .photoItem:nth-child(27) {
        filter: blur(0.76px);
    }
}

.affPro-section3 {
    background: url("../assets/image/partner2/s2Bg.webp") no-repeat;
}

.affPro-section3 h2 {
    color: var(--ebc-text-primary_white);
}

.affPro-section3CardList {
    gap: 24rem;
    margin-top: 64rem;
}

.affPro-section3Card {
    gap: 20rem;
    overflow: hidden;
    min-height: 500rem;
    max-height: 500rem;
    flex-direction: column;
    align-items: flex-start;
    border-radius: var(--ebc-corner-radius-rc24);
    background: var(--ebc-neutral-bg_a);
    padding: 56rem 0 64rem 40rem;
}

.affPro-section3Card.active {
    padding: 64rem 0 64rem 56rem;
    flex: 0 0 700rem;
    flex-direction: row;
    align-items: flex-end !important;
}

@media (min-width: 996px) {
    .ar .affPro-section3Card {
        padding: 56rem 40rem 64rem 0;

    }

    .ar .affPro-section3Card.active {
        padding: 64rem 56rem 64rem 0;

    }

    .ru .affPro-section3Card.active {
        flex: 0 0 680rem;
    }

    .mn .affPro-section3Card.active,
    .ug .affPro-section3Card.active {
        flex: 0 0 600rem
    }

    .ru .affPro-section3Card {
        flex: 0 0 316rem;
        max-height: 550rem;
        height: 550rem;
    }

    .ug .affPro-section3Card,
    .mn .affPro-section3Card {
        flex: 0 0 276rem;
        max-height: 550rem;
        height: 550rem;
    }
}

.affPro-section3Card {
    flex: 0 0 226rem;
    transition: flex 0.3s linear;
}

.affPro-s2CardTitle {
    color: var(--ebc-text-primary);
    font-size: 32rem;
    font-weight: 500;
    line-height: 40rem;
}

.affPro-section3Card .controlShow>div:nth-child(2) {
    margin-block: 12rem 40rem;
}

.affPro-section3Card .controlShow {
    height: 100%;
    flex-direction: column;
}

.affPro-section3Card .controlShow div:nth-child(n + 2),
.affPro-section3Card .controlShow a {
    display: none;
    opacity: 0;
}

.affPro-section3Card.active .controlShow div:nth-child(n + 2),
.affPro-section3Card.active .controlShow a {
    display: block;
    animation: controlShow 0.3s forwards;

}

.affPro-section3Card.active .controlShow a {
    white-space: nowrap
}

.affPro-section3Card.active .controlShow a:hover {
    background-color: var(--ebc-basecolor-active-400);
}

@keyframes controlShow {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.affPro-section3Card .controlShow a {
    margin-top: auto;
    color: var(--ebc-text-primary_white);
    background-color: var(--ebc-brand-secondary-red);
    padding: 8rem 32rem;
    border-radius: var(--ebc-corner-radius-full);
}

.affPro-section3Card img {
    transform: translateX(56rem);
}

.affPro-section3Card.active img {
    transform: translateX(0);
}

.affPro-section3Card img {
    width: 240rem;
    min-width: 240rem;
    height: 240rem;
    margin-bottom: -48rem;
    opacity: 0.5;
}

.affPro-section3Card.active img {
    opacity: 1;
}

@media (max-width: 996px) {
    .affPro-section3 {
        background-repeat: repeat;
    }

    .affPro-section3CardList {
        flex-direction: column !important;
        gap: 32rem;
    }

    .affPro-section3Card {
        max-height: unset;
    }

    .affPro-section3Card.active {
        flex: 1;
    }

    .affPro-section3Card.active {
        border-radius: 16px;
        padding: 56rem 32rem;
        flex-direction: column !important;
        text-align: center;
        min-height: unset;
        gap: 48rem;
    }

    .affPro-section3Card .affPro-s2CardTitle {
        font-size: 40rem;
        font-weight: 500;
        line-height: 56rem;
    }

    .affPro-section3Card .controlShow {
        align-items: center !important;
        order: 2;
    }

    .affPro-section3Card img {
        width: 400rem;
        height: 400rem;
        margin-inline: auto;
    }

    .affPro-section3Card .controlShow a {
        width: 100%;
        height: 80rem;
        padding: 16rem 48rem;
        line-height: 48rem;
        margin-top: 48rem;
    }

    .affPro-section3Card .controlShow>div:nth-child(2) {
        margin-block: 16rem 32rem;
    }
}

.affPro-section4 {
    color: var(--ebc-text-primary_white);
    background: linear-gradient(180deg, #16161a 0%, #2b2b33 100%);
}

.affPro-section4 .aff4Container {
    margin-top: 56rem;
    gap: 24rem;
}

.affPro-section4 .aff4Item {
    border-radius: var(--ebc-corner-radius-rc24);
    background: rgba(255, 255, 255, 0.05);
    transition: transform 0.3s ease-in-out;
}

.affPro-section4 .aff4Item:hover {
    background: rgba(255, 255, 255, 0.1);

}

.affPro-section4 .aff4Item:nth-child(-n + 2) {
    flex: 0 0 588rem;
}

.affPro-section4 .aff4Item:nth-child(-n + 2) img {
    width: 100%;
    height: auto;
}

.affPro-section4 .aff4Item:nth-child(-n + 2) .s4Word {
    padding: 40rem;
}

.affPro-section4 .aff4Item .s4Word div:nth-child(2) {
    margin-top: 12rem;
}

.affPro-section4 .aff4Item:nth-child(n + 3) {
    flex: 0 0 384rem;
    padding: 40rem;
}

.affPro-section4 .aff4Item:nth-child(n + 3) .s4Word {
    margin-top: 32rem;
}

.affPro-section4 .aff4Item:nth-child(n + 3) img {
    width: 40rem;
    height: 40rem;
}

@media (max-width: 996px) {
    .affPro-section4 .aff4Container {
        flex-direction: column;
        gap: 32rem;
    }

    .affPro-section4 .aff4Item {
        flex: 1;
        text-align: center;
    }

    .affPro-section4 .aff4Item .s4Word div:nth-child(1) {
        font-size: 36rem;
        line-height: 56rem;
    }

    .affPro-section4 .aff4Item .s4Word div:nth-child(2) {
        font-size: 28rem;
        line-height: 48rem;
        margin-top: 16rem;
    }

    .affPro-section4 .aff4Item:nth-child(-n + 2) .s4Word {
        padding-top: 8rem;
    }

    .affPro-section4 .aff4Item:nth-child(n + 3) img {
        width: 80rem;
        height: 80rem;
    }
}

.affPro-section5 {
    background: var(--ebc-neutral-bg_b);
}

.affPro-section5 .s3SwiperContainer {
    gap: 80rem;
    margin-top: 64rem;
    background-color: var(--ebc-neutral-bg_a);
    border-radius: var(--ebc-corner-radius-rc24);
    overflow: hidden;
    padding-right: 80rem;
}

.affPro-section5 .s3SwiperContainer .left {
    flex: 0 0 600rem;
    overflow: hidden;
}

@media (min-width: 996px) {
    .affPro-section5 .s3SwiperContainer .right {
        height: 260rem;
        display: flex;
        flex-direction: column;
    }

    .affPro-section5 .s3NavigatePart {
        margin-top: auto;
    }
}

.affPro-section5 .s3Swiper img {
    width: 600rem;
    height: 420rem;
    border-radius: 24rem;
}

.affPro-section5 .s3wordItem {
    display: none;
}

.affPro-section5 .s3wordItem.active {
    display: block;
}

.affPro-section5 .s3Desc {
    margin-top: 16rem;
}

.affPro-section5 .s3NavigatePart svg {
    width: 48rem;
    height: 48rem;
    outline: none !important;
}

.affPro-section5 .s3NavigatePart svg:hover path:nth-child(1) {
    fill: #a52933;
    stroke: transparent;
}

.affPro-section5 .s3NavigatePart svg:hover path:nth-child(2) {
    stroke: #fff;
}

.affPro-section5 .s3NavigatePart .s3Next {
    margin-left: 12rem;
}

.affPro-section5 .s3NavigatePart .s3Navigate {
    gap: 8px;
}

.affPro-section5 .s3NavigatePart .s3Navigate div.active {
    width: 32px;
    height: 2px;
    background: var(--ebc-brand-secondary-red);
}

.affPro-section5 .s3NavigatePart .s3Navigate div {
    width: 12px;
    height: 2px;
    border-radius: var(--ebc-corner-radius-full);
    background: var(--ebc-neutral-divider_medium);
}

@media (max-width: 996px) {
    .affPro-section5 {
        padding-bottom: 140rem;
    }

    .s3NavigateBtn {
        display: none !important;
    }

    .s3SwiperContainer .right .s3NavigatePart {
        justify-content: center;
    }

    .s3SwiperContainer .right .s3NavigatePart {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 130rem);
    }

    .affPro-section5 .s3wordItem {
        text-align: center;
    }

    .affPro-section5 .s3Desc {
        margin-top: 32rem;
    }

    .affPro-section5 .s3SwiperContainer {
        flex-direction: column;
        width: 100%;
        gap: 56rem;
        padding: 56rem 32rem;
        margin-top: 56rem;
        border-radius: 32rem;
        overflow: visible;
    }

    .affPro-section5 .s3SwiperContainer .left {
        flex: 0 0 100%;
        max-width: 100%;
        overflow: hidden;
    }

    .affPro-section5 .s3SwiperContainer .left img {
        width: 100%;
        height: auto;
        border-radius: 8px;
    }
}

.affPro-section6 {
    overflow: hidden;
    padding: 120rem 0;
}

.affPro-section6 .aff6List {
    gap: 24rem;
    margin-top: 56rem;
    overflow: auto;
    padding-right: 32rem;
    align-items: normal;
    padding-inline: calc(50vw - 600rem);
}

.affPro-section6 .aff6List::-webkit-scrollbar {
    display: none;
}

.affPro-section6 .aff6Item {
    cursor: pointer;
}

.affPro-section6 .aff6Item video {
    width: 100%;
    height: 450rem;
    object-fit: cover;
    min-width: 700rem;
    border-radius: 24px;

}

.affPro-section6 .aff6Item img {
    border-radius: 24px;
    height: 450rem;
    min-width: 700rem;

}

.affPro-section6 .aff6Item:nth-child(1) video {
    min-width: 550rem;
}

.affPro-section6 .aff6Item .aff6Title {
    width: 100%;
    margin: 28rem 0 8rem;
    padding-inline: 30rem;
    color: var(--ebc-text-primary) !important;
}

.affPro-section6 .aff6Item div {
    padding-inline: 30rem;
}

.affPro-section6 .aff6Item:hover .iconfont {
    display: block;
}

.affPro-section6 .aff6Item .iconfont {
    font-size: 20rem;
    color: var(--ebc-brand-secondary-red);
    display: none;
}

.affPro-section6 .aff6ListPageNavigate {
    text-align: right;
    padding-right: calc(50vw - 600rem);
    margin-top: 56rem;
}

.affPro-section6 .aff6ListPageNavigate svg.disabled {
    pointer-events: none;
}

.affPro-section6 .aff6ListPageNavigate svg.disabled path {
    stroke-opacity: .24;
    fill: unset !important;
}

.affPro-section6 .aff6ListPageNavigate svg path {
    stroke-opacity: 1;
}

.affPro-section6 .aff6ListPageNavigate svg:hover path:nth-child(1) {
    fill: #a52933;
    stroke: transparent;
}

.affPro-section6 .aff6ListPageNavigate svg:hover path:nth-child(2) {
    stroke: #fff;
}

@media (max-width: 996px) {
    .affPro-section6 {
        padding: 80rem 0;
    }

    .affPro-section6 .aff6List {
        gap: 32rem;
        padding-inline: 32rem;
    }

    .affPro-section6 .aff6Item .aff6Title {
        width: 100%;
        margin: 48rem 0 16rem;
        padding-inline: 30rem;
    }

    .affPro-section6 .aff6Item .aff6Title .iconfont {
        display: none;
    }

    .affPro-section6 .aff6ListPageNavigate {
        padding-right: 32rem;
    }

    .affPro-section6 .aff6ListPageNavigate svg {
        width: 80rem;
        height: 80rem;
    }

    .affPro-section6 .aff6ListPageNavigate span:nth-child(2) {
        margin-left: 16rem;
    }
}

.affPro-section8 {
    background: #4d1726;
}

.affPro-section8 h2 {
    margin-bottom: 56rem;
    color: var(--ebc-text-primary_white);
}

.aff8SwiperList {
    gap: 24rem;
}

.aff8SwiperList .aff8Left {
    flex: 0 0 400rem;
    position: relative;
}

.aff8SwiperList .aff8Left .largeImg {
    width: 100%;
    height: auto;
    border-radius: var(--ebc-corner-radius-rc24);
}

.aff8SwiperList .s8Swiper {
    border-radius: var(--ebc-corner-radius-rc24);
    background: var(--ebc-neutral-bg_a);
    flex: 1;
    overflow: hidden;
    max-width: 100%;
}

.aff8SwiperList .aff8Right {
    padding: 56rem;
}

.aff8SwiperList .aff8Right .aff8Word {
    margin-block: 28rem 63rem;
    color: var(--ebc-text-primary);
    font-size: 18rem;
    font-style: normal;
    font-weight: 500;
    line-height: 32rem;
}

.affPro-section8 .swiper-slide {
    height: auto;
}

.affPro-section8 .aff8Right {
    display: flex;
    flex-direction: column;
}

.affPro-section8 .aff8Right .aff8Intro {
    margin-top: auto;
}

.affPro-section8 .aff8Right .introL {
    gap: 16rem;
}

.affPro-section8 .aff8Right .topIcon {
    width: 48rem;
    height: 37rem;
}

.affPro-section8 .aff8Right .introL .introHeader {
    border-radius: 50%;
    padding: 0;
    background-color: #5d2333;
    color: var(--ebc-text-primary_white);
    text-align: center;
    font-size: 32rem;
    font-weight: 500;
    line-height: 64rem;
    width: 64rem;
    height: 64rem;
}

.affPro-section8 .aff8Right .introL .introName {
    margin-bottom: 4rem;
}

.affPro-section8 .aff8Right .introR img {
    width: auto;
    height: 24rem;
}

.affPro-section8 .s8Navigate {
    gap: 8rem;
    margin-top: 56rem;
}

.affPro-section8 .s8Navigate div {
    width: 12px;
    height: 2px;
    border-radius: 999px;
    background-color: rgba(255, 255, 255, 0.32);
    cursor: pointer;
}

.affPro-section8 .s8Navigate div.active {
    background: var(--ebc-brand-accent-coral);
    width: 32px;
}

.affPro-section8 {
    --size: 48px;
    --overlap: 24px;
    --ring: 1px;
    --speed: 500ms;
}

.s8Left-stack {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
}

.s8Left-avatar {
    width: var(--size);
    height: var(--size);
    border-radius: 999px;
    border: var(--ring) solid rgba(255, 255, 255, 0.95);
    background: rgba(255, 255, 255, 0.12);
    object-fit: cover;
    box-sizing: border-box;
    margin-left: calc(var(--overlap) * -1);
    position: relative;
    will-change: transform;
    user-select: none;
    -webkit-user-drag: none;
}

@media (max-width: 996px) {
    .affPro-section8 .contentBox {
        padding: 100rem 32rem;
    }

    .affPro-section8 .aff8Left {
        order: 2;
        gap: 40rem;
    }

    .affPro-section8 .aff8SwiperList {
        flex-direction: column;
        gap: 40rem;
    }

    .affPro-section8 .s8Swiper {
        max-width: 100%;
    }

    .affPro-section8 .aff8Right .topIcon {
        height: 48rem;
        width: auto;
    }

    .aff8SwiperList .aff8Right {
        padding: 56rem 32rem;
        border-radius: 32px;
    }

    .aff8SwiperList .aff8Right .aff8Word {
        font-size: 28rem;
        line-height: 48rem;
        font-weight: 500;
        margin-block: 56rem;
    }

    .affPro-section8 .aff8Right .introL .introHeader {
        width: 104rem;
        height: 104rem;
        font-size: 52rem;
        line-height: 104rem;
    }

    .affPro-section8 .aff8Right .introL {
        gap: 24rem;
    }

    .affPro-section8 .aff8Right .introL .introName {
        margin-bottom: 8rem;
    }

    .affPro-section8 .aff8Right .introL .introName+div {
        font-size: 28rem;
        line-height: 44rem;
    }

    .aff8SwiperList .aff8Right .aff8Intro {
        margin-top: auto;
    }

    .affPro-section8 .aff8Left {
        flex: 0 0 300rem;
    }

    .affPro-section8 .topIcon {
        width: 240rem !important;
    }

    .aff8SwiperList .aff8Left .largeImg {
        border-radius: 32rem;
        width: 700rem;
        height: 300rem;
        object-fit: cover;
        object-position: center;
    }

    .affPro-section8 .s8Navigate {
        margin-top: 106rem;
    }
}

/* 遮罩层 */
.s7Card-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    z-index: 50;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
}

.s7Card-overlay.active {
    opacity: 1;
    pointer-events: auto;
}

.affPro-section7 {
    background: linear-gradient(180deg, #2b2b33 0%, #16161a 100%);
}

.affPro-section7 h2 {
    color: var(--ebc-text-primary_white);
}

.affPro-section7 .s7CardList {
    gap: 24rem;
    margin-top: 52rem;
}
.s7Card-cardWrapper a{
  gap: 4rem;
  margin-top: 36rem;
}
.s7Card-cardWrapper a span{
  color: #fff;
}
.s7Card-cardWrapper a svg{
  width: 17px;

}
.s7Card-cardWrapper a:hover svg{
  animation: slide-right 0.6s ease-out both;
}
@keyframes slide-right {
  0% {
    transform: translate(-10px,0);
    opacity: 0;
  }

  100% {
    transform: translateX(0,0);
    opacity: 1;
  }
}
.affPro-section7 .s7Card-cardWrapper:nth-child(1),
.affPro-section7 .s7Card-cardWrapper:nth-child(2),
.affPro-section7 .s7Card-cardWrapper:nth-child(n + 3) .imageCard {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 24px;
    position: relative;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(n + 3) {
    perspective: 1400px;
    position: relative;
    height: 400rem;
    border-radius: 24px;
}

.s7Card-card {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    transform-style: preserve-3d;
    transition: transform 0.2s linear;
    transform-origin: center center;
}

.s7Card-cardWrapper.is-flipped .s7Card-card {
    transform: rotateY(180deg);
}

.s7Card-cardWrapper.is-expanded {
    z-index: 200;
    perspective: none !important;
}

/* 卡片展开时的样式 - 只设置固定定位 */
.s7Card-card.is-expanding {
    position: fixed !important;
    z-index: 200 !important;
    margin: 0 !important;
}

/* 启用动画过渡 */
.s7Card-card.is-animating {
    transition: all .3s linear !important;
}

/* 卡片展开到中心的最终状态 */
.s7Card-card.is-center {
    left: 50% !important;
    top: 50% !important;
    width: 860rem !important;
    height: 500rem !important;
    transform: translate(-50%, -50%) rotateY(180deg) !important;
}

.s7Card-back .backWord .bottomDesc {
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 11;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

/* 展开时保持圆角 */
.s7Card-card.is-expanding .s7Card-front,
.s7Card-card.is-expanding .s7Card-back {
    border-radius: 24px;
}

/* 背面内容显示控制 */
.s7Card-back .backWord {
    display: none;
}

.s7Card-card.is-center .s7Card-back .backWord {
    display: block;
}

/* 动画完成后才显示溢出内容 */
.s7Card-card.is-animation-complete .s7Card-back {
    overflow: visible;
}

.s7Card-front {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 24px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
}

.s7Card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    background: #fff;
    border-radius: 24px;
    overflow: hidden;
    transform: rotateY(180deg);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
    color: #fff;
}

.s7Card-back .closeIcon {
    position: absolute;
    width: 32rem !important;
    height: 32rem !important;
    top: 32rem;
    right: 32rem;
    cursor: pointer;
}

@media (min-width: 996px) {
    .ar .s7Card-back .closeIcon {
        right: unset;
        left: 32rem;
    }

}

.s7Card-back .backContainer {
    height: 100%;
}

.s7Card-back .backPhoto {
    background: var(--ebc-neutral-divider_regular);
    flex: 0 0 300rem;
    height: 100%;
}

.s7Card-back .backPhoto img {
    height: 530rem !important;
    width: auto !important;
    transform: translateY(-30rem);
    border-bottom-left-radius: 24px;
}

.s7Card-back .backWord {
    flex: 1;
    padding: 64rem 72rem;
    color: #000;
    display: none;
}

.s7Card-back .splitLine {
    background: var(--ebc-neutral-divider_regular);
    height: 1px;
    margin-block: 40rem 32rem;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(n + 3) .imageCard:hover {
    background: rgba(255, 255, 255, 0.6);
}

.affPro-section7 .s7Card-cardWrapper:nth-child(n + 3) .imageCard .openIcon {
    cursor: pointer;
    display: none;
    width: 32rem;
    height: 32rem;
    text-align: center;
    border-radius: 50%;
    position: absolute;
    right: 16rem;
    top: 16rem;
    background: var(--ebc-brand-secondary-red);
}

.affPro-section7 .s7Card-cardWrapper:nth-child(n + 3) .imageCard .openIcon img {
    width: 19rem;
    height: 19rem;
    margin-top: 7rem;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(n + 3) .imageCard:hover .openIcon {
    display: block;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(1) {
    flex: 0 0 384rem;
    height: 400rem;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(1) img {
    width: 384rem;
    height: 420rem;
    transform: translateY(-19rem);
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(2) {
    flex: 0 0 792rem;
    color: var(--ebc-text-primary_white);
    padding: 0 64rem;
    flex-direction: column;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(2) .splitLine {
    background: var(--ebc-neutral-divider_regular_white);
    margin-block: 32rem;
    height: 1px;
    width: 100%;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(2) .topCardJob {
    font-size: 16rem;
    line-height: 24rem;
    margin-top: 20rem;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(n + 3) {
    flex: 0 0 282rem;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(n + 3) .imageCard {
    height: 323rem;
    overflow: hidden;
    width: 100%;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(n + 3) .s7CardName {
    margin-top: 12rem;
    color: var(--ebc-text-primary_white);
    text-align: center;
}

.affPro-section7 .s7Card-cardWrapper:nth-child(n + 3) img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
    transition: transform .2s linear;
}

.s7Card-cardWrapper:nth-child(n + 3) .imageCard:hover img {
    transform: scale(1.1);
}

@media (max-width: 996px) {
  .affPro-section7>a{
    color: #fff;
    margin: 14rem auto 28rem;
    width: fit-content;

  }
  .affPro-section7 h2{
    text-align: center;
  }
    .s7Card-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.50);
        z-index: 10;
    }

    .affPro-section7 {
        padding: 80rem 0 80rem 32rem;
    }

    .affPro-section7 .memberList {
        margin-top: 56rem;
        gap: 32rem;
        overflow: auto;
        padding-right: 32rem;
    }

    .affPro-section7 .memberList::-webkit-scrollbar {
        display: none;
    }

    .affPro-section7 .memberItem {
        position: relative;
        border-radius: 16px;
        overflow: hidden;
        flex: 0 0 546rem;
    }

    .affPro-section7 .photoPart {
        background: rgba(255, 255, 255, 0.05);
    }

    .affPro-section7 img {
        width: 546rem;
        height: 629rem;
        object-fit: cover;
        object-position: top;
    }

    .affPro-section7 .memberName {
        margin-top: 32rem;
        color: var(--ebc-text-primary_white);
        text-align: center;
    }

    .affPro-section7 .photoPart .openIcon {
        position: absolute;
        right: 32rem;
        top: 32rem;
        width: 64rem;
        height: 64rem;
        background-color: var(--ebc-brand-secondary-red);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .affPro-section7 .photoPart .openIcon img {
        width: 38rem;
        height: 38rem;
    }

    .s7Dial {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 11;
        border-radius: 32rem;
        width: 686rem;
        background-color: #fff;
        display: none
    }

    .s7Dial.active {
        display: block
    }

    .s7Dial .DialItem.active {
        display: block;
    }

    .s7Dial .DialItem {
        display: none;
    }

    .s7Dial .topImg {
        background: rgba(0, 0, 0, .12);
        height: 340rem;
        text-align: center;
    }

    .s7Dial .topImg img {
        width: 608rem;
        height: 460rem;
        object-fit: cover;
        object-position: top;
        transform: translateY(-120rem);
    }

    .s7Dial .bottomWord {
        padding: 48rem 32rem 56rem;
        max-height: 50vh;
        overflow: auto;
    }

    .s7Dial .bottomWord .memName {
        font-size: 40rem;
        font-weight: 500;
        line-height: 56rem;
        margin-bottom: 24rem;
    }

    .s7Dial .bottomWord .memJob {
        font-size: 28rem;
        font-weight: 400;
        line-height: 48rem;
        margin-bottom: 15rem
    }

    .s7Dial .bottomWord .memDesc {
        margin-top: 32rem;
        font-size: 28rem;
        font-weight: 400;
        line-height: 48rem;
    }

    .s7Dial .closeIcon {
        position: absolute;
        top: -66rem;
        right: 0;
        width: 45rem;
        height: 45rem;

    }
}
</style>
